import { Label, Select, SelectOption } from '@eppendorf/vnls-react-components';
import React, { ReactElement, useMemo } from 'react';

import { PageList } from './page-list';
import { PaginationProps } from './pagination.definitions';
import styles from './pagination.module.scss';

function transformToSelectOptions(arr: number[]): SelectOption[] {
  return arr.map((n) => ({
    label: `${n}`,
    value: `${n}`,
  }));
}

export function Pagination({
  paginationData,
  onPageChange,
  pageSiblingCount,
  onPageSizeChange,
  pageSizeOptions,
  showItemRange = true,
  showPageSize = true,
  selectLabel,
  itemRangeLabel,
}: PaginationProps): ReactElement | null {
  const { currentPage, pageSize, totalPages, totalItems } = paginationData;

  const startItem = useMemo(
    () => (currentPage - 1) * pageSize + 1,
    [currentPage, pageSize],
  );
  const isLastPage = useMemo(() => totalPages === currentPage, [totalPages, currentPage]);
  const endItem = useMemo(
    () => (isLastPage ? totalItems : Math.min(currentPage * pageSize, totalItems)),
    [isLastPage, totalItems, currentPage, pageSize],
  );

  return (
    <div className={styles.pagination}>
      {showItemRange && (
        <p className={styles['pagination__item-range']}>
          {itemRangeLabel(startItem, endItem)}
        </p>
      )}

      <PageList
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        pageSiblingCount={pageSiblingCount}
        className={styles.pagination__pagelist}
      />

      {showPageSize && (
        <div className={styles['pagination__rows-per-page-container']}>
          {selectLabel && (
            <Label className={styles['pagination__rows-per-page-label']} htmlFor="">
              {selectLabel}
            </Label>
          )}
          <Select
            className={styles['pagination__rows-per-page-container-select']}
            value={`${pageSize}`}
            onChange={onPageSizeChange}
            options={transformToSelectOptions(pageSizeOptions)}
          />
        </div>
      )}
    </div>
  );
}
